import { render } from "./BaseSpinner.vue?vue&type=template&id=a73526e0&scoped=true&ts=true"
import script from "./BaseSpinner.vue?vue&type=script&lang=ts"
export * from "./BaseSpinner.vue?vue&type=script&lang=ts"

import "./BaseSpinner.vue?vue&type=style&index=0&id=a73526e0&lang=scss&scoped=true"

import exportComponent from "C:\\DevOps\\FrancoisAgent\\_work\\8\\s\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.2.41_vue@3.2.41_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a73526e0"]])

export default __exports__